var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PromotionForm',{attrs:{"promotion":_vm.promotion,"buttonLoading":_vm.buttonLoading},on:{"savePromotion":_vm.savePromotion}})}
var staticRenderFns = []

export { render, staticRenderFns }